export const API_URL = `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/en/`
